import React from 'react';
import { useLocation } from 'react-router-dom';

interface PageTransitionProps {
  children: React.ReactNode;
}

/**
 * Soft-nav enter animation for retail routes.
 * Admin routes skip transform/opacity: a leftover transform creates a containing
 * block for position:fixed (mobile header), which clips the dashboard after
 * login→dashboard until a hard refresh.
 */
const PageTransition: React.FC<PageTransitionProps> = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isCreatorChatWidgetRoute = location.pathname.startsWith('/widget/chat/');

  const baseStyle: React.CSSProperties = {
    position: 'relative',
    width: '100%',
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    minHeight: 0,
  };

  if (isAdminRoute || isCreatorChatWidgetRoute) {
    return (
      <div
        className={`page-container${isCreatorChatWidgetRoute ? ' page-container--creator-chat-widget' : ' page-container--admin'}`}
        style={baseStyle}
      >
        {children}
      </div>
    );
  }

  return (
    <div
      key={location.pathname}
      className="page-container"
      style={{
        ...baseStyle,
        opacity: 0,
        transform: 'translateX(10px)',
        animation: 'pageEnter 0.2s ease-out forwards',
      }}
    >
      {children}
    </div>
  );
};

export default PageTransition;
